import { useReactOidc } from '@axa-fr/react-oidc-context';

const useIsNotActiveCustomer = () => {
  const { oidcUser } = useReactOidc();

  return oidcUser.profile.notactivecustomer;
};

export default useIsNotActiveCustomer;